interface AreaLimitConfig {
  maxZoomFactor: number;
  globalMaxAreaKm2: number;
  recommendedMinZoom: number;
  appliesToStyles: string[];
}

const DEFAULT_CONFIG: AreaLimitConfig = {
  maxZoomFactor: 0.6,
  globalMaxAreaKm2: 36.0,
  recommendedMinZoom: 11.4,
  appliesToStyles: ['osm2world'],
};

let cachedConfig: AreaLimitConfig | null = null;

/**
 * Fetch area limit config from backend. Cached for the session.
 * Backend pre-computes recommendedMinZoom — no client-side conversion needed.
 */
export async function fetchAreaLimitConfig(): Promise<AreaLimitConfig> {
  if (cachedConfig) return cachedConfig;

  const apiUrl = import.meta.env.VITE_API_BASE_URL;

  if (!apiUrl) {
    console.warn('[AreaConfig] API URL not configured, using defaults');
    return DEFAULT_CONFIG;
  }

  try {
    const response = await fetch(`${apiUrl}/v1/config/area-limits`);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    if (
      typeof data?.recommendedMinZoom !== 'number' ||
      !Number.isFinite(data.recommendedMinZoom)
    ) {
      console.warn('[AreaConfig] Invalid response shape, using defaults');
      return DEFAULT_CONFIG;
    }
    cachedConfig = data as AreaLimitConfig;
    return cachedConfig;
  } catch (err) {
    console.warn('[AreaConfig] Failed to fetch area limits, using defaults:', err);
    return DEFAULT_CONFIG;
  }
}
